import { reportStatus } from '@/enums/reportStatus'
import BaseService from '@/services/baseService'
import { HTTP } from '@/http.js'

export default class PodiumReportService extends BaseService {
  // TODO: required?
  static async getReports(
    status = [reportStatus.GENERATED],
    summaryStatuses,
    noOfReports = 100,
    product = 'metaxplore',
    page = 1,
    sortBy = 'id',
    sortDirection = 'desc',
    keyword = ''
  ) {
    return super.callStore('getReports', {
      status,
      summaryStatuses,
      noOfReports,
      product,
      page,
      sortBy,
      sortDirection,
      keyword
    })
  }

  static async getPodiumReport(sampleId, resultId) {
    return super.callStore('getPodiumReport', { sampleId, resultId })
  }

  static async getDraftSummaryExpertSummary(productCode, sampleId, referralId) {
    return super.callStore('getDraftSummaryByReferral', { productCode, sampleId, referralId })
  }

  static async getPodiumDraftSummary(resultId) {
    return super.callStore('getPodiumDraftSummary', { resultId })
  }

  static async saveNote(payload) {
    return super.callStore('saveNote', payload)
  }

  static async transitionReport(payload) {
    return super.callStore('transitionReport', payload)
  }

  // Evicts the podium V3 report response cache for a result (base R… or
  // versioned R…-N id) so the next report fetch regenerates from fresh data.
  static async invalidateV3ReportCache(resultId) {
    return HTTP.delete(`/podium/internal/v3-cache/${encodeURIComponent(resultId)}`)
  }

  static async sendLabEvent(fileName) {
    // Extract S3 path from the environment variable (s3://db-sample-file-staging/lab/LabLIMS)
    const s3LabLimsUrl = process.env.VUE_APP_S3_LAB_LIMS_BUCKET
    if (!s3LabLimsUrl) {
      throw new Error('VUE_APP_S3_LAB_LIMS_BUCKET environment variable is not defined')
    }
    const s3Path = s3LabLimsUrl.replace(/^s3:\/\/[^/]+\//, '') // Extract path: lab/LabLIMS
    const key = `${s3Path}/${fileName}`

    // Extract bucket name from environment variable (handles both bucket name and full S3 URL)
    const bucket = s3LabLimsUrl.startsWith('s3://') ? s3LabLimsUrl.replace(/^s3:\/\/([^/]+).*/, '$1') : s3LabLimsUrl

    // Matches the podium-intake lab LIMS import contract: { bucket, key, etag }
    const payload = {
      bucket,
      key,
      etag: 'Uploaded from staff portal'
    }

    return HTTP.post('/v1/lab/imports', payload)
  }
}
